import React from 'react';
import styled from 'styled-components';
import { Router } from '@reach/router';
import PrivateRoute from './private-route';
import LoggedOutRoute from './logged-out-route';

import Login from './login';
import Signup from './signup';
import Dashboard from './dashboard';

const AccountsContainer = styled.div``;

const Accounts = () => {
    return (
        <AccountsContainer>
            <Router basepath="/accounts">
                <LoggedOutRoute default path="/login" component={Login} />
                <Signup path="/signup" />
                <PrivateRoute path="/dashboard/*" component={Dashboard} />
            </Router>
        </AccountsContainer>
    );
};

export default Accounts;
